import { createSlice } from "@reduxjs/toolkit";
import { fetchPharmacistOfPharmacy } from "../../apis/dispense/pharmacistOfPharmacy";

const initialState = {
	loading: false,
	data: null,
	error: null
}

const pharmacistOfPharmacyListSlice = createSlice({
	name: 'fetchPharmacistOfPharmacy',
	initialState,

	extraReducers: (builder) => {
		builder.addCase(fetchPharmacistOfPharmacy.pending.type, (state) => {
			return {
				...state,
				loading: true,
				// data: null,
				error: null
			}
		})

		builder.addCase(fetchPharmacistOfPharmacy.fulfilled.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			}
		})

		builder.addCase(fetchPharmacistOfPharmacy.rejected.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: null,
				error: action.payload
			}
		})
	}

})

export default pharmacistOfPharmacyListSlice.reducer